import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { Theme } from "@mui/material/styles";

const CRMExportStyles = makeStyles((theme: Theme) =>
    createStyles({
        customDialogPaper: {
            width: 560,
            borderRadius: "8px",
        },
        checkboxContainer: {
            display: "flex",
            alignItems: "center",
            marginRight: theme.spacing(2),
        },
        dialogHeader: {
            padding: theme.spacing(1, 3, 1, 3),
            alignItems: "center",
            justifyContent: "space-between",
            display: "flex",
        },
        subheaderText: {
            fontWeight: 500,
            color: theme.palette.secondary.main,
        },
        leadersListContainer: {
            background: theme.palette.background.blue,
            borderRadius: "8px",
            overflowY: "scroll",
        },
        leaderRoleContainer: {
            display: "flex",
            fontSize: 12,
            justifyItems: "start",
            alignItems: "center",
            margin: theme.spacing(0, 1),
        },
        leaderNoRole: {
            color: theme.palette.error.main,
        },
        leaderRowSelected: {
            background: theme.palette.background.green,
        },
        leaderRowExported: {
            background: theme.palette.background.grey,
            "& *": {
                opacity: 0.75,
            },
            "& $leaderNoRole": {
                color: theme.palette.text.primary,
            },
        },
        leaderRowWrapper: {
            display: "flex",
            alignItems: "center",
            justifyItems: "center",
            height: 44,
        },
        leaderRowDivider: {
            display: "flex",
            alignSelf: "center",
            width: "1px",
            height: "17px",
            backgroundColor: theme.palette.divider,
        },
        leaderRowHorizontalDivider: {
            width: "98%",
            height: "1px",
            backgroundColor: theme.palette.divider,
            margin: "auto",
        },
        leaderNameWrapper: {
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            flex: 1,
            paddingLeft: theme.spacing(1),
            fontSize: 14,
        },
        longlistIcon: {
            color: theme.palette.button.active.from,
            fontSize: 22,
        },
        shortlistIcon: {
            color: theme.palette.text.lightBlue,
            fontSize: 22,
        },
        selectedVacancyContainer: {
            background: theme.palette.background.green,
            borderRadius: "8px",
            padding: theme.spacing(1),
            display: "flex",
            alignItems: "center",
        },
        noVacancyContainer: {
            background: theme.palette.background.green,
            borderRadius: "8px",
            padding: theme.spacing(1),
        },
        selectVacancy: {
            display: "flex",
            marginBottom: theme.spacing(1),
        },
        selectAllText: {
            alignSelf: "center",
            letterSpacing: 1.25,
            fontSize: 12,
        },
        usersIcon: {
            color: theme.palette.neutrals.main,
            fontSize: 20,
            marginRight: theme.spacing(1),
        },
        vacancy: {
            fontSize: 16,
            fontWeight: 600,
            color: theme.palette.text.secondary,
        },
        addIcon: {
            color: theme.palette.success.main,
        },
        noResults: {
            display: "flex",
            height: 170,
            backgroundColor: theme.palette.background.blue,
            margin: "auto",
        },
        removeIcon: {
            color: theme.palette.error.main,
        },
        loadingBlurryBg: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            left: "50%",
            borderRadius: theme.spacing(1.5),
            backdropFilter: "blur(10px)",
            padding: theme.spacing(1),
            width: "95%",
            height: "calc(100% - 120px)",
            zIndex: 2,
            transform: "translate(-50%,0%)",
            border: `1px solid ${theme.palette.neutrals.light}`,
        },
        loadingWrapper: {
            width: "100%",
            maxWidth: 380,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        },
        loadingMessage: {
            marginTop: theme.spacing(3),
            fontSize: 14,
        },
    })
);

export default CRMExportStyles;
